AppTabs.createTab( {
	name: 'worklist',
	icon: 'list',
	text: 'Worklist',
	actionElementClasses: [ 'test-worklist-link' ],
	create: function(init) {
		'use strict'

		const progress                = document.getElementById( 'worklist-progress-info' ),
			progressBar               = progress.querySelector('.progress-bar' ),
			progressMessage           = progress.querySelector( '.progress-message' ),
			mainContent               = document.getElementById( 'worklist-main' ),
			header                    = document.getElementById( 'worklist-header' ),
			dateSpan                  = document.getElementById( 'worklist-date' ),
			rowBackgroundColor        = '#eee',
			rowAltBackgroundColor     = '#f9f9f9';
		let multiTest                 = true,
			currentSampleNumber       = null,
			tbody                     = null,
			errorDiv                  = null,
			currentRowBackgroundColor = rowBackgroundColor,
			progressPercentage        = 0.0,
			eventSource               = null,
			entry                     = null,
			headerText = "",
			headerDate = "";

		function resetAll() {
			if ( tbody && tbody.parentNode )
				mainContent.removeChild(tbody.parentNode);

			if ( errorDiv )
				mainContent.removeChild(errorDiv);

			multiTest                 = true;
			currentSampleNumber       = null;
			tbody                     = null;
			currentRowBackgroundColor = rowBackgroundColor;
			progressPercentage        = 0.0;
			eventSource               = null;
			entry                     = null;
		}

		function updateProgress( progress, message ) {
			progressPercentage = parseFloat( progress );
			progressBar.innerText = progressPercentage.toFixed( 1 ) + '%';
			progressMessage.innerText = message;
		}

		function updateProgressBar() {
			if ( progressBar.length == 0 ) { return; }
			progressBar.style.display = null;
			const progressWidth = progressPercentage.toFixed( 2 ) + '%';
			if ( progressBar.style.width != progressWidth ) {
				progressBar.style.width = progressWidth;
			}

			if ( progressPercentage != 100 ) {
				setTimeout( updateProgressBar, 200 );
			}
		}

		function makeTd( content ) {
			const td = document.createElement('td');
			td.append( content );
			return td;
		}

		function makeUList( items ) {
			const ul = document.createElement('ul');
			for (const item of items) {
				const li = document.createElement('li');
				li.append( item );
				ul.append( li );
			}
			return ul;
		}

		function makeTh( content ) {
			const td = document.createElement('td');
			td.append( content );
			return td;
		}

		function makeHeaderTrs(part) {
			let worklistHeader = document.createElement('tr');
			worklistHeader.className = "worklist-name";
			let worklistNameHeader = makeTh(headerText);
			worklistNameHeader.colSpan = 5;
			worklistHeader.append(worklistNameHeader);

			let worklistDateHeader = makeTh(headerDate);
			worklistDateHeader.colSpan = 2;
			worklistHeader.append(worklistDateHeader);
			part.append( worklistHeader );

			let tr = document.createElement('tr');
			tr.append( makeTh( 'Sample #' ) );
			tr.append( makeTh( 'Shelves' ) );
			tr.append( makeTh( 'Client' ) );
			tr.append( makeTh( 'Sample Description' ) );
			tr.append( makeTh( 'Sample From' ) );
			tr.append( makeTh( 'Sample To' ) );
			tr.append( makeTh( 'Preservation' ) );
			part.append( tr );
			const colSpan = tr.childNodes.length - (multiTest ? 2 : 0);
			tr = document.createElement('tr');
			if ( multiTest ) {
				const thTests = makeTh( 'Tests' );
				thTests.colSpan = 2;
				tr.append( thTests );
			}
			const th = makeTh( 'Lab Comment' );
			th.colSpan = colSpan;
			tr.append( th );
			part.append( tr );
		}

		function addEntry( entry ) {
			if ( entry == null ) { return; }
			// Create table if it does not exists
			if ( tbody == null ) {
				const table = document.createElement('table');
				table.className = 'table w-100';
				const thead = document.createElement('thead');
				makeHeaderTrs( thead );
				table.append( thead );
				tbody = document.createElement('tbody');
				table.append( tbody );
				const tfoot = document.createElement('tfoot');
				makeHeaderTrs( tfoot );
				table.append( tfoot );
				mainContent.append( table );
			}

			// Swap background for every sample
			if ( entry.SampleNumber != currentSampleNumber) {
				currentSampleNumber = entry.SampleNumber;
				currentRowBackgroundColor = currentRowBackgroundColor == rowBackgroundColor ? rowAltBackgroundColor : rowBackgroundColor;
			}

			let tr = document.createElement('tr');
			tr.style.backgroundColor = currentRowBackgroundColor || '';
			tr.append( makeTd( entry.SampleNumber || '' ) );
			tr.append( makeTd( entry.Shelf || '' ) );
			tr.append( makeTd( entry.ClientDisplayName || '' ) );
			tr.append( makeTd( entry.SampleDescription || '' ) );
			tr.append(makeTd(entry.SampleFromDate
				? getUnzonedLocaleDate(entry.SampleFromDate)
				: ''));
			tr.append(makeTd(entry.SampleToDate
				? getUnzonedLocaleDate(entry.SampleToDate)
				: ''));
			tr.append( makeTd( entry.Preservation || '' ) );
			tbody.append( tr );
			const colSpan = tr.childNodes.length - (multiTest ? 2 : 0);
			tr = document.createElement('tr');
			tr.style.backgroundColor = currentRowBackgroundColor || '';
			if ( multiTest ) {
				const tdTests = makeTd( entry.Tests.length ? makeUList(entry.Tests) : null );
				tdTests.colSpan = 2;
				tr.append( tdTests );
			}
			const tdComment = makeTd( entry.LabComment || '' );
			tdComment.colSpan = colSpan;
			tr.append( tdComment );
			tbody.append( tr );
		}

		function run(tests, metals = null, loginDate = null){
			resetAll();
			let eventSourceUrl = ajax_object.ajax_url + '?action=get_worklist&session_id=' + encodeURIComponent(ajax_object.session_id);
			if ( tests && tests.length )
				eventSourceUrl += '&' + tests.map( test => 'testId[]=' + ( (typeof test === 'object' && 'id' in test) ? test.id : test) ).join( '&' )
			else if ( metals )
				eventSourceUrl += '&testId=metals';

			if ( loginDate )
				eventSourceUrl += '&log-in-date=' + loginDate;

			eventSource = new EventSource( eventSourceUrl );

			progress.style.display = null;
			updateProgress( 0, 'Fetching Worklist' );

			//a message is received
			eventSource.addEventListener( 'message', function(e) {
				var result = JSON.parse( e.data );

				updateProgress( result.progress, typeof result.message == 'string' ? result.message : result.message.message );

				switch ( e.lastEventId ) {
					case 'ERROR':
						eventSource.close();

						console.log(e);

						// Create alert if there is no table
						if ( tbody == null ) {
							const div = document.createElement('div');
							div.className = 'alert alert-waring';
							div.innerText = 'There were no worklist or log list items found in the database.';
							mainContent.append( div );
						}
						break;

					case 'CLOSE':
						eventSource.close();
						addEntry( entry );
						updateProgress( result.progress, '' );
						progress.style.display = 'none';
						break;

					case 'SETUP':
						multiTest = ! result.message.isSingleTestList;
						headerText = 'Worklist for ' + result.message.name;
						var today = new Date();
						var dd = String(today.getDate()).padStart(2, '0');
						var mm = String(today.getMonth() + 1).padStart(2, '0');
						var yyyy = today.getFullYear();
						headerDate = mm + '/' + dd + '/' + yyyy;
						if ( result.message.logInDate ) { headerDate = result.message.logInDate; }
						break;

					default:
						if ( result.message.entry ) {
							if (entry == null || entry.SampleNumber != result.message.entry.SampleNumber ) {
								addEntry( entry );
								entry = result.message.entry;
								entry.Tests = [ entry.TestName ];
							} else {
								entry.Tests.push( result.message.entry.TestName )
							}
						}
				}
			});

			eventSource.addEventListener('error', function(e) {
				eventSource.close();

				console.log(e);

				errorDiv = document.createElement('div');
				errorDiv.className = 'alert alert-warning';
				errorDiv.innerText = 'An error occurred: No additional information was provided by the server.';
				tbody ? mainContent.insertBefore( errorDiv, tbody ) : mainContent.append( errorDiv );
			});

			updateProgressBar();
		}

		const tab = this;
		init.setController( {
			openTestWorklist(tests) {
				tab.show();
				run( tests );
			},
			openMetalsWorkList() {
				tab.show();
				run( null, true );
			},
			openMetalsLogList(date) {
				tab.show();
				run( null, true, date );
			},
			doElementAction: function(target, elClass, event) {
				tab.show();
                run( [ target.dataset['testId'] ] );
			},
			onCloseTab: resetAll,
		} );
	}
});
